"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _CalculatorContainer = require("./CalculatorContainer");
Object.keys(_CalculatorContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalculatorContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CalculatorContainer[key];
    }
  });
});
var _CalculatorContainerMobile = require("./CalculatorContainerMobile");
Object.keys(_CalculatorContainerMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CalculatorContainerMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CalculatorContainerMobile[key];
    }
  });
});